<template>
  <v-container>
    <v-row class="main-container">
      <v-col>
        <v-card class="mx-auto" max-width="1000">
          <v-card-text class="hidden-md-and-up" style="padding-bottom: 0px">
            <v-tabs :value="onMatchTab() ? 0 : 1">
              <v-tabs-slider color="#428751"></v-tabs-slider>
              <v-tab :to="{ name: 'Match' }" active-class="activeTab"> Match </v-tab>
              <v-tab :to="{ name: 'Search' }" active-class="activeTab"> Search </v-tab>
            </v-tabs>
          </v-card-text>
          <v-card-text style="padding-bottom: 0px">
            <div v-if="onMatchTab()" style="height: 80px">
              Let us match you with a professional for greater success.
              <div v-if="presetCategoryName">
                <router-link :to="{ name: 'Match' }" style="font-size: 13px">
                  Not looking for {{ presetCategoryName }}? Browse all categories
                </router-link>
              </div>
            </div>
            <div v-else style="height: 80px">
              Know what you want?
              <v-text-field
                placeholder="Example: Health Coach"
                hide-details
                clearable
                outlined
                style="max-width: 400px"
                v-model="searchText"
                @click:append="search"
              ></v-text-field>
            </div>
          </v-card-text>
          <v-card-text v-if="loggedIn">
            Zip Code
            <span
              ><zipcodeorcity
                @signupAlert="signupAlert"
                :searchZipcode="true"
                style="max-width: 400px"
                @selectedZipOrCity="selectedZipOrCity"
            /></span>
            <br />
            <br />
            City
            <zipcodeorcity
              @signupAlert="signupAlert"
              :searchZipcode="false"
              style="max-width: 400px"
              @selectedZipOrCity="selectedZipOrCity"
            />
            State
            <v-autocomplete
              :readonly="!loggedIn"
              @click="signupAlert"
              v-model="selectedState"
              hide-details
              clearable
              outlined
              style="max-width: 400px"
              :items="states()"
              item-text="name"
              item-value="abbreviation"
            >
              <template v-slot:append>
                <v-icon color="#428751">mdi-arrow-down-drop-circle</v-icon>
              </template>
            </v-autocomplete>
          </v-card-text>

          <v-card-text>
            <v-expansion-panels outlined accordion v-model="panel" max-width="1000">
              <template v-if="onMatchTab()">
                <v-expansion-panel v-for="(item, index) in shownQuestions" :key="index" :value="index">
                  <v-expansion-panel-header class="list-title" style="text-transform: uppercase"
                    ><template v-slot:actions>
                      <v-icon>
                        {{ panel != index + 1 ? 'mdi-plus' : 'mdi-close' }}
                      </v-icon> </template
                    >{{ item.title }}</v-expansion-panel-header
                  >
                  <v-expansion-panel-content>
                    <ask-questions
                      @signupAlert="signupAlert"
                      :currentQuestion="item"
                      @nextSection="nextSection()"
                      @cancelAskQuestion="cancelAskQuestion"
                    />
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </template>
              <v-expansion-panel :value="generalInfoPanel">
                <v-expansion-panel-header class="list-title"
                  ><template v-slot:actions>
                    <v-icon>
                      {{ panel != generalInfoPanel ? 'mdi-plus' : 'mdi-close' }}
                    </v-icon> </template
                  >GENERAL INFORMATION</v-expansion-panel-header
                >
                <v-expansion-panel-content>
                  <EditProfileInfo
                    @signupAlert="signupAlert"
                    :section="sections().MEMBER"
                    @nextSection="nextSection()"
                  />
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-card-text>

          <v-card-text>
            <v-btn class="mr-4 main-btn success-green" @click="search()" id="searchId">
              {{ onMatchTab() ? 'Find My Matches' : 'Search' }}
            </v-btn>
          </v-card-text>

          <v-alert v-if="error" type="error">
            {{ error }}
          </v-alert>
          <v-card-text v-for="category in shownCategories()" :key="category.id">
            <CategorySearchResult
              :users="categoryUsers[category.id]"
              :category="category"
              :tags="tags"
              :maxPriority="maxPriority"
            />
          </v-card-text>
          <v-dialog v-model="dialog" max-width="320">
            <v-card class="pa-1">
              <v-card-title class="headline"> No professionals found </v-card-title>
              <v-card-text>
                Thank you for becoming a FourWordz Member. We are beta testing the site now while certified
                professionals continue to join.
              </v-card-text>
              <v-card-text>
                Please try broadening your filters or in Preferred Location change to Web Conferencing only.
              </v-card-text>
              <v-card-text> If you have any questions please contact: info@WholeLifeGoals.com </v-card-text>
              <v-card-text> With gratitude, </v-card-text>
              <v-card-text> The FourWordz Team </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn class="mr-4 main-btn success-green" text @click="dialog = false"> Ok </v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
              <v-alert v-if="errorDialog" type="error">
                {{ errorDialog }}
              </v-alert>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialog2" max-width="320">
            <v-card class="pa-1">
              <br />
              <v-card-text>
                Select the green Search button at the bottom left corner on this tab to view search results.
              </v-card-text>
              <v-card-text
                >Add your email address to unlock Search, Match, and Preferred Location filters for in-person
                appointments in the General Information tab.
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn class="mr-4 main-btn success-green" text @click="dialog2 = false"> Ok </v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
              <v-alert v-if="errorDialog" type="error">
                {{ errorDialog }}
              </v-alert>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialog3" max-width="320">
            <v-card class="pa-1">
              <br />
              <v-card-text> Matching is available only for users with verified email address. </v-card-text>
              <v-card-text
                >Add your email address to unlock Search, Match, and Preferred Location filters for in-person
                appointments in the General Information tab.
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn class="mr-4 main-btn success-green" text @click="dialog3 = false"> Ok </v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
              <v-alert v-if="errorDialog" type="error">
                {{ errorDialog }}
              </v-alert>
            </v-card>
          </v-dialog>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
/* eslint-disable no-debugger */
import EditProfileSections from '../profile/EditProfileSections';

import API from '../../api';
import CategorySearchResult from './CategorySearchResult';
import EditProfileInfo from '../profile/EditProfileInfo';
import questionsStore from '@/components/member/questionsStore';
import goTo from 'vuetify/lib/services/goto';
import statesJSON from '../../../data/states.json';
import loginStore from '../../util/loginStore';

export default {
  name: 'Search',

  components: {
    EditProfileInfo,
    CategorySearchResult
    //Matching,
    //Tags,
  },
  props: {
    mode: {
      type: String,
      default: 'search',
      validator: v => ['match', 'search'].includes(v)
    }
  },
  data: () => ({
    tags: [],
    error: null,
    profile: {},
    searchText: '',
    // -1 = nothing open by default. GENERAL INFORMATION's :value is
    // shownQuestions.length, which changes depending on category preset -
    // pinning panel to a fixed number like 0 or 1 here would coincidentally
    // match it and pop the wrong panel open. loadData() sets this
    // explicitly once shownQuestions is finalized instead.
    panel: -1,
    panelInitialized: false,
    oldPanel: 0,
    users: [],
    dialog: false,
    dialog2: false,
    dialog3: false,
    zipcode: '',
    categories: [],
    categoryUsers: {},
    selectedZipObject: {},
    preferredHome: false,
    preferredClient: false,
    preferredOnline: false,
    preferredAgreedUpon: false,
    free15: false,
    workWeekends: false,
    selectedState: '',
    errorDialog: false,
    maxPriority: 1
  }),
  mounted() {
    this.setTitle();
  },
  activated() {
    // <keep-alive> restores cached instances without re-running mounted()
    this.setTitle();
  },
  async created() {
    if (this.$route.query.search) {
      this.searchText = this.$route.query.search;
    }
  },
  methods: {
    signupAlert() {
      if (!this.loggedIn) {
        this.dialog2 = true;
      }
    },
    async loadData() {
      questionsStore.created();
      this.error = null;
      let res = await API.get('profile?noAuth=true');
      if (!res) {
        return;
      }
      if (res.errors && res.errors.length > 0) {
        this.error = res.errors[0].msg;
      } else {
        this.categories = res.data.categories;
        this.tags = res.data.tags;
        await this.resolveCategoryParam();
        // panel stays at its initial -1 here on purpose - nothing auto-opens
        // on load, Match tab included.
      }
    },
    categorySlug(name) {
      return (name || '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/(^-|-$)/g, '');
    },
    async resolveCategoryParam() {
      // Resolve this before touching presetTagId either way, so
      // shownQuestionsList() always runs against the full question list
      // instead of racing an in-flight fetch.
      await questionsStore.created();

      const slug = this.$route.query.category;
      if (!slug) {
        // questionsStore is a global singleton shared across the whole app,
        // so a preset from a previous /match?category=... visit must be
        // explicitly cleared here - otherwise it leaks into this page load.
        questionsStore.clearPresetCategoryTag();
        return;
      }
      const match = this.categories.find(c => this.categorySlug(c.name) === slug.toLowerCase());
      if (!match) {
        questionsStore.clearPresetCategoryTag();
        return;
      }

      // match.id is the Categories table row id (used for grouping search
      // results); match.tagId is the actual tag id Questions.ifTagId checks
      // against (these differ for Money: id 4, tagId 26). Pre-seeding the
      // follow-up questions needs tagId, not id.
      questionsStore.presetCategoryTag(match.tagId);

      // Ad-campaign traffic lands with a category pre-selected; auto-run the
      // search so they see matches immediately instead of hitting an empty page.
      this.search();
    },
    states() {
      return statesJSON;
    },
    selectedZipOrCity(val) {
      this.selectedZipObject = val;
    },
    sections() {
      return EditProfileSections;
    },
    shownCategories() {
      let res = [];
      for (let index = 0; index < this.categories.length; index++) {
        const category = this.categories[index];
        if (this.categoryUsers[category.id]) {
          res.push(category);
        }
      }
      return res;
    },
    onMatchTab() {
      return this.mode === 'match';
    },
    setTitle() {
      document.title = this.onMatchTab() ? 'Match' : 'Search';
    },
    async search() {
      setTimeout(() => {
        this.doSearch();
      }, 100);
    },
    async doSearch() {
      var searchParameters = {};
      if (!this.onMatchTab()) {
        searchParameters.text = this.searchText;
      }
      if (this.selectedZipObject) {
        if (this.selectedZipObject.type == 'city') {
          searchParameters.city = this.selectedZipObject.name;
        } else {
          searchParameters.zipcode = this.selectedZipObject.name;
        }
      }
      if (this.selectedState) {
        searchParameters.state = this.selectedState;
      }

      let res = await API.post('search', searchParameters);
      if (res.errors && res.errors.length > 0) {
        this.error = res.errors[0].msg;
      } else {
        this.error = null;
        this.users = res.data.users;
        this.categoryUsers = {};
        if (!res.data.users.length) {
          this.dialog = true;
          return;
        }
        let maxPriority = 0;
        for (let index = 0; index < res.data.users.length; index++) {
          const user = res.data.users[index];
          if (user.priority > maxPriority) {
            maxPriority = user.priority;
          }
          for (let index2 = 0; index2 < user.userCategories.length; index2++) {
            let userCategory = user.userCategories[index2];
            let users = this.categoryUsers[userCategory.categoryId];
            if (!users) {
              users = [];
              this.categoryUsers[userCategory.categoryId] = users;
            }
            users.push(user);
          }
        }
        for (const key in this.categoryUsers) {
          if (Object.hasOwnProperty.call(this.categoryUsers, key)) {
            this.categoryUsers[key].sort((a, b) => b.priority - a.priority);
          }
        }
        this.maxPriority = parseInt(maxPriority);
      }
      goTo('#searchId');
    },
    async matchProfile() {
      this.dialog = true;
    },
    random() {
      return '' + Math.random();
    },
    showCurrentFiler() {
      return true;
    },
    nextSection() {
      setTimeout(() => {
        this.panel = -1;
      }, 300);
    },
    async cancelAskQuestion() {
      await questionsStore.created();
      this.panel = -1;
    }
  },

  computed: {
    shownQuestions() {
      return questionsStore.shownQuestions;
    },
    loggedIn() {
      return loginStore.loggedIn;
    },
    presetCategoryName() {
      const slug = this.$route.query.category;
      if (!slug) return null;
      const match = this.categories.find(c => this.categorySlug(c.name) === slug.toLowerCase());
      return match ? match.name : null;
    },
    // Fixed sentinel for GENERAL INFORMATION's panel slot, instead of
    // shownQuestions.length. That length changes per category preset and
    // can briefly equal whatever panel happens to be set to during load,
    // popping GENERAL INFORMATION open by coincidence. A value no real
    // question index will ever reach removes that collision entirely.
    generalInfoPanel() {
      return 999;
    }
  },
  watch: {
    loggedIn: {
      handler() {
        this.loadData();
        console.log('panel:', this.panel, 'shownQuestions:', this.shownQuestions.length);
      },
      deep: true,
      immediate: true
    },
    panel: {
      handler(value) {
        if (value == 0) {
          this.signupAlert();
        }
      },
      deep: true,
      immediate: true
    }
  }
};
</script>

<style scoped>
.avatar {
  width: 140px !important;
  height: 140px !important;
  top: -70px !important;
  left: 30px !important;
  border: 5px solid #fff;
}
.activeTab {
  color: #428751 !important;
}
.main-container {
  font-family: 'Nunito', sans-serif !important;
}
.tabs .indicator {
  background-color: #428751 !important;
} /*Color of underline*/
</style>
